import { normalizeParamsObject } from 'shared-lib/helpers/formatters';
import cloneDeep from 'lodash/cloneDeep';
import { saveElement, getSavedElement, resetElement, saveElementInSession, getSavedElementInSession, resetElementInSession } from 'shared-lib/helpers/local-storage';

const types = {
    SAVE_FILTERS: 'SAVE_FILTERS',
    RESET_FILTERS: 'RESET_FILTERS',
};

const getters = {
    storedFilters (state) {
        const isNotChanged = !state.isChanged;
        const namespace = state.namespace ? `-${state.namespace}` : '';
        const savedElementInSessionStorage = isNotChanged && state.useSessionStorage && getSavedElementInSession(`filters${namespace}`);
        const savedElementInLocalStorage = isNotChanged && state.useLocalStorage && getSavedElement(`filters${namespace}`);

        return savedElementInSessionStorage || savedElementInLocalStorage || state.filters || {};
    },
};

const actions = {
    saveFilters ({ commit, state }, filters) {
        const filtersNormalized = normalizeParamsObject(filters);
        commit(types.SAVE_FILTERS, filtersNormalized);

        const namespace = state.namespace ? `-${state.namespace}` : '';
        state.useSessionStorage && saveElementInSession(`filters${namespace}`, filtersNormalized);
        state.useLocalStorage && saveElement(`filters${namespace}`, filtersNormalized);
    },
    resetFilters ({ commit, state }) {
        commit(types.RESET_FILTERS);

        const namespace = state.namespace ? `-${state.namespace}` : '';
        state.useSessionStorage && resetElementInSession(`filters-${namespace}`);
        state.useLocalStorage && resetElement(`filters-${namespace}`);
    },
};

const mutations = {
    [types.SAVE_FILTERS] (state, filters) {
        state.isChanged = true;
        state.filters = { ...filters };
    },
    [types.RESET_FILTERS] (state) {
        state.filters = cloneDeep(state.initialFilters || {});
    },
};

const state = (initialState, namespace = '') => ({
    ...cloneDeep(initialState),
    namespace,
    isChanged: false,
    initialFilters: cloneDeep(initialState.filters),
});

export default (initialState, namespace) => ({
    namespaced: true,
    getters,
    actions,
    mutations,
    state: state(initialState, namespace),
});
